module.exports = "<svg id=\"i-search\" viewBox=\"0 0 32 32\" width=\"32\" height=\"32\" fill=\"none\" stroke=\"currentcolor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"6.25%\">\n  <circle cx=\"14\" cy=\"14\" r=\"12\" />\n  <path d=\"M23 23 L30 30\"  />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/svg/search.svg
// module id = 86
// module chunks = 0